import { render } from "./HRAddMessage.vue?vue&type=template&id=ab1f97ec&scoped=true"
import script from "./HRAddMessage.vue?vue&type=script&lang=js"
export * from "./HRAddMessage.vue?vue&type=script&lang=js"

import "./HRAddMessage.vue?vue&type=style&index=0&id=ab1f97ec&scoped=true&lang=scss"

import exportComponent from "/Users/berkuralcan/Documents/dev/webdev/dansuk-engineering-dashboard-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab1f97ec"]])

export default __exports__